import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserRefreshUserToken, useUsers } from "../sevices/hooks/users";
import LoadingScreen from "../pages/Notifications/LoadingScreen2";
import Aside from "../components/dashboard-components/Aside";
import Nav from "../components/dashboard-components/Nav";
import { useGbpRates, useRates, useRatesEur } from "../sevices/hooks/tags";
import { useRatesState, useUserState } from "../store";
import InviteUsers from "../components/base-components/InviteUsers";
import AutoLogout from "../pages/authentication/AutoLogout";
import { TimeoutModal } from "../components/dashboard-components/timeoutModal";
import { useIdle } from "../hooks/useIdle";
import { toast } from "sonner";
// import Aside from "../components/dashboard-components/DesktopAside";
// import MobileAside from "../components/dashboard-components/MobileAside";

const DashBoardLayout = () => {
  const setUSDRates = useRatesState((state) => state.setUSDRate);
  const setEURRates = useRatesState((state) => state.setEURRate);
  const setGBPRates = useRatesState((state) => state.setGBPRate);
  const [showModal, setShowModal] = useState(false);
  const setUserDetails = useUserState((state) => state.setUserDetails);
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [userId, setUserId] = useState("");
  const [timeUntilExpiration, setTimeUntilExpiration] = useState<number | null>(null);
  const [modalDismissed, setModalDismissed] = useState(false);
  const currentRate = useRates();
  const eurRates = useRatesEur();
  const gbpRates = useGbpRates();
  const refreshUserToken = useUserRefreshUserToken();
  const getUserDetails = useUsers(
    //@ts-ignore
    localStorage.getItem("user_id"),
    localStorage.getItem("accessToken")
  );
  const IDLE_TIMEOUT = 600000; // 10 minutes
  const { getLastActiveTime } = useIdle(IDLE_TIMEOUT);
  // const activeLink = (path: string) => {
  //   if (location.pathname === '/dashboard' && path === "") {
  //     return "border-l-4 border-[#0eb683] bg-[#F7FBFB]"
  //   }

  //   return location.pathname === '/dashboard/' + path ? "border-l-4 border-[#0eb683] bg-[#F7FBFB]" : ""
  // }


  // Token Expiration Logic
  React.useEffect(() => {
    const checkTokenExpiration = () => {
      const currentToken = localStorage.getItem("accessToken");
      const expirationStr = localStorage.getItem("tokenExpiration");

      if (!currentToken) {
        setTimeUntilExpiration(null);
        return;
      }

      let timeUntilExp = 0;

      if (expirationStr) {
        timeUntilExp = parseInt(expirationStr) - Date.now();
        const expirationDate = new Date(parseInt(expirationStr));
        const now = new Date();

        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        console.log("🕐 SESSION EXPIRATION CHECK");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        console.log("Current Time:", now.toLocaleTimeString());
        console.log("Expires At:", expirationDate.toLocaleTimeString());
        console.log("Time Until Expiration:", Math.floor(timeUntilExp / 1000), "seconds");
        const formatTime = (seconds: number) => {
          const m = Math.floor(seconds / 60);
          const s = seconds % 60;
          return `${m}:${s < 10 ? "0" : ""}${s}`;
        };
        console.log("Time Until Expiration (formatted):", formatTime(Math.floor(timeUntilExp / 1000)));

        const WARNING_THRESHOLD = 300000; // 5 minutes

        if (timeUntilExp > WARNING_THRESHOLD) {
          const timeUntilModalShows = timeUntilExp - WARNING_THRESHOLD;
          console.log("Estimated time until timeout modal shows (if idle):", formatTime(Math.floor(timeUntilModalShows / 1000)));
        }

        // We can't know the exact original token duration without decoding it, but if it gave > 15 mins total, we'll guesstimate spent time assuming a standard 1 hr token issuing frame
        const estimatedElapsed = Math.floor((Date.now() - (expirationDate.getTime() - 60 * 60 * 1000)) / 1000);
        console.log("ESTIMATED Token Lifespan spent (assuming 1h token):", formatTime(estimatedElapsed > 0 ? estimatedElapsed : 0));
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
      } else {
        // Fallback if no expiration stored
        setTimeUntilExpiration(null);
        console.warn("⚠️ No tokenExpiration found in localStorage");
        return;
      }

      // Update timeUntilExpiration for sidebar badge
      setTimeUntilExpiration(timeUntilExp);

      // Thresholds
      const WARNING_THRESHOLD = 300000; // 5 minutes
      const AUTO_REFRESH_ACTIVITY_WINDOW = 120000; // 2 minutes - user must be active within this window for auto-refresh

      if (timeUntilExp <= 0) {
        // Token expired, force logout
        console.log("❌ TOKEN EXPIRED - Logging out");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        handleLogout();
        return;
      }

      // TRIGGER: If we are getting close to expiration (e.g. less than 5 mins)
      if (timeUntilExp < WARNING_THRESHOLD) {
        const timeSinceLastActive = Date.now() - getLastActiveTime();
        // User is considered active if they had activity within the window or if they just started working (isUserIdle is false)
        const isUserActive = timeSinceLastActive < AUTO_REFRESH_ACTIVITY_WINDOW;

        console.log("⚠️ WARNING THRESHOLD REACHED (< 5 minutes)");
        console.log("Time Until Expiry:", Math.floor(timeUntilExp / 1000), "seconds");
        console.log("Time Since Last Active:", Math.floor(timeSinceLastActive / 1000), "seconds");

        // Case 1: User is active - Auto-refresh "under the hood"
        if (isUserActive) {
          if (!refreshUserToken.isLoading) {
            console.log("✅ User is ACTIVE - Auto-refreshing session...");
            console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
            handleExtendSession();
          }
        } 
        // Case 2: User is inactive - Show modal
        else {
          if (!showModal && !modalDismissed) {
            console.log("💤 User is INACTIVE - Showing timeout modal");
            console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
            setShowModal(true);
          } else if (modalDismissed) {
            console.log("🔕 Modal was dismissed and user still inactive");
            console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
          }
        }
      } else {
        console.log("✅ Session is healthy ( > 5 minutes remaining)");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
      }
    };

    // Run immediately on mount
    checkTokenExpiration();

    // Then check every 10 seconds
    const interval = setInterval(checkTokenExpiration, 10000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, modalDismissed, refreshUserToken.isLoading]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  }

  const handleDismissModal = () => {
    setShowModal(false);
    setModalDismissed(true);
  }

  const handleReopenModal = () => {
    setShowModal(true);
    setModalDismissed(false);
  }

  const handleExtendSession = () => {

    const refreshToken = localStorage.getItem("refreshToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!refreshToken) {
      toast.error("Session expired. Please login again.");
      handleLogout();
      return;
    }


    refreshUserToken.mutateAsync({ refreshToken, accessToken: accessToken! }).then((res) => {
      // console.log("Refresh token response:", res);
      const newToken = res?.data?.data?.token || res?.data?.token;
      const newRefreshToken = res?.data?.data?.refreshToken || res?.data?.refreshToken;

      if (newToken) {
        // console.log("New token received:", newToken);
        localStorage.setItem("accessToken", newToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

        // Update tokenExpiration if provided (we might need to update the hook/api to return it if it's there)
        // Assuming the refresh endpoint returns the same structure or we default to +10 mins (600s) if not,
        // OR better: use the `expiresIn` from response if available.
        // The current response `res` might need `expiresIn`.
        // Inspecting `res` in the hook...

        const expiresInValue = res?.data?.data?.expiresIn || res?.data?.expiresIn;
        if (expiresInValue) {
          const expiresIn = Number(expiresInValue);
          const expirationTime = Date.now() + expiresIn * 1000;
          const newExpirationDate = new Date(expirationTime);
          localStorage.setItem("tokenExpiration", expirationTime.toString());

          console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
          console.log("🔄 SESSION REFRESHED SUCCESSFULLY");
          console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
          console.log("New Token Received");
          console.log("Expires In:", expiresIn, "seconds (", Math.floor(expiresIn / 60), "minutes)");
          console.log("New Expiration Time:", newExpirationDate.toLocaleTimeString());
          console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        } else {
          // Fallback: 10 minutes
          const expirationTime = Date.now() + 600000;
          localStorage.setItem("tokenExpiration", expirationTime.toString());
        }

        setShowModal(false);
        setModalDismissed(false); // Reset dismissal state on successful refresh
        // toast.success("Session extended successfully");
      } else {
        // console.error("Token not found in response:", res);
        // toast.error("Failed to parse session data.");
        handleLogout();
      }
    }).catch((error) => {

      handleLogout();
    })


  }

  useEffect(() => {
    let token = localStorage.getItem("accessToken") || "";
    let user_id = localStorage.getItem("user_id") || "";
    setToken(token);
    setUserId(user_id);
  }, [token, userId]);

  useEffect(() => {
    // console.log(getUserDetails);

    // if (getUserDetails.status === 'error') {
    //   navigate('/login')
    // }

    // if (getUserDetails.isError) {
    //   navigate('/login')
    // }

    setUserDetails(getUserDetails.result?.data);
  }, [
    getUserDetails.isError,
    getUserDetails.result?.data,
    getUserDetails.status,
    navigate,
    setUserDetails,
  ]);

  // useEffect(() => {
  //   setUSDRates(currentRate?.data?.data.toFixed(2));

  //   setEURRates(eurRates?.data?.data.toFixed(2));
  //   setGBPRates(gbpRates?.data?.data.toFixed(2));
  // }, [
  //   currentRate?.data?.data,
  //   currentRate.status,
  //   eurRates?.data?.data,
  //   eurRates.status,
  //   gbpRates?.data?.data,
  //   gbpRates.status,
  //   setEURRates,
  //   setGBPRates,
  //   setUSDRates,
  // ]);

  return (
    // <LoadingScreen
    //   showLoading={
    //     getUserDetails.status === "loading" ||
    //     currentRate.status === "loading" ||
    //     (!getUserDetails.isSuccess && getUserDetails.isError)
    //   }
    // >


    // <AutoLogout>
      <div className="dashboard overflow-x-hidden h-screen">
        <div className="flex flex-1">
          <div>
            <Aside />
          </div>

          <div className="grid grid-rows-[auto_1fr] w-full h-screen overflow-auto">
            <Nav />
            <main className="overflow-x-hidden">
              <Outlet context={[getUserDetails.result?.data]} />
            </main>
        </div>
        <TimeoutModal
          isOpen={showModal}
          onClose={handleLogout}
          onDismiss={handleDismissModal}
          onExtendSession={handleExtendSession}
          isLoading={refreshUserToken.isLoading}
          timeUntilExpiration={timeUntilExpiration || 300000}
        />
        </div>
        <InviteUsers data={getUserDetails.result?.data} />
      </div>
    // </AutoLogout>
    // </LoadingScreen>
  );
};

export default DashBoardLayout;
